import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function ViewConvenioEstadual() {
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  function formatBRL(value) {
    if (value === null || value === undefined || value === "") return "-";
    const num = Number(value);
    if (isNaN(num)) {
      console.log("Valor inválido para formatação:", value);
      return "-";
    }
    return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  const carregarDados = () => {
    axios
      .get("/api/conveniosestadual")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("Erro no axios:", err);
        alert("Erro ao carregar dados do servidor");
      });
  };

  useEffect(() => {
    const userRole = localStorage.getItem("UserRole");
    setIsAdmin(userRole === "admin");
    carregarDados();
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Tem certeza que deseja deletar este lançamento?")) {
      axios
        .delete(`/api/conveniosestadual/${id}`)
        .then((res) => {
          if (res.data.message === "Convenio deletado com sucesso!") {
            alert("Convenio deletado!");
            carregarDados();
          } else {
            alert("Erro ao deletar o lançamento");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="fs-11 px-18 py-8" style={{ overflow: "visible" }}>
      <div className="d-flex justify-content-center mb-3">
        <h3>Convenios ESTADUAL</h3>
      </div>

      <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
        {isAdmin && (
          <Link to="/addconveniosestadual" className="btn btn-primary">
            + Novo Convenio
          </Link>
        )}
        <Link to="/conveniosdade" className="btn btn-secondary">
          Convenio DADE
        </Link>
        <Link to="/conveniosfederal" className="btn btn-secondary">
          Convênios FEDERAL
        </Link>
        <Link to="/conveniosfinisa" className="btn btn-secondary">
          Convênios FINISA
        </Link>
        <Link to="/conveniossempapel" className="btn btn-secondary">
          Convênios SEM PAPEL
        </Link>

        <input
          type="text"
          placeholder="Buscar por Projeto, Empresa, Conta..."
          className="form-control"
          style={{ maxWidth: "300px" }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table className="table table-responsive table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th>ID</th>
              <th>Projeto</th>
              <th>Nº Convênio</th>
              <th>Ano</th>
              <th>Repasse (R$)</th>
              <th>Contrapartida (R$)</th>
              <th>Valor Total (R$)</th>
              <th>Assinatura Termo</th>
              <th>Vigência Convênio</th>
              <th>Vigência Contrato</th>
              <th>Empresa</th>
              <th>Fiscal / Contador</th>
              <th>Conta Bancária</th>
              <th>Status</th>
              {isAdmin && <th>Ações</th>}
            </tr>
          </thead>

          <tbody>
            {data
              .filter((item) => {
                const search = searchTerm.toLowerCase();
                return (
                  item.projeto?.toLowerCase().includes(search) ||
                  item.numero_convenio?.toString().includes(search) ||
                  item.ano?.toString().includes(search) ||
                  item.empresa?.toLowerCase().includes(search) ||
                  item.fiscal?.toLowerCase().includes(search) ||
                  item.conta_bancaria?.toLowerCase().includes(search) ||
                  item.status?.toLowerCase().includes(search)
                );
              })
              .map((item, index) => (
                <tr key={index}>
                  <td>{item.id}</td>
                  <td>{item.projeto}</td>
                  <td>{item.numero_convenio}</td>
                  <td>{item.ano}</td>
                  <td>{formatBRL(item.repasse)}</td>
                  <td>{formatBRL(item.contrapartida)}</td>
                  <td>{formatBRL(item.valor_total)}</td>
                  <td>{item.assinatura_termo}</td>
                  <td>{item.vigencia_convenio}</td>
                  <td>{item.vigencia_contrato}</td>
                  <td>{item.empresa}</td>
                  <td>{item.fiscal}</td>
                  <td>{item.conta_bancaria}</td>
                  <td>{item.status}</td>
                  {isAdmin && (
                    <td>
                      <button
                        className="btn btn-light btn-sm me-2"
                        onClick={() =>
                          navigate(`/addconveniosestadual/${item.id}`)
                        }
                      >
                        Editar
                      </button>

                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => handleDelete(item.id)}
                      >
                        Deletar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewConvenioEstadual;
